import { initializeFirebase } from '@tritt/firebase-client'
import { ref } from 'vue'
import { useFirestoreService } from '@/services/infrastructure/firestore.service'
import { useFunctionService } from '@/services/infrastructure/function.service'
import { useStorageService } from '@/services/infrastructure/storage.service'
import { contaBaseUrl } from '@/services/infrastructure/ServerBasePathResolver'

const demoMode = ref(false)


export const isDemoMode = () => {
    return !!demoMode.value
}

/**
 * Initialize Firebase and related services.
 * Returns the Firebase services for use by the BootstrapService.
 * Note: Auth initialization is now handled by BootstrapService.
 */
export const initializeFirebaseClient = async () => {
    const fbServices = await initializeFirebase('pracsys')

    demoMode.value = fbServices.isEmulator
    contaBaseUrl.value = window.location.protocol === 'http:'
        ? fbServices.urls.trittApi.replace('https', 'http')
        : fbServices.urls.trittApi

    // Initialize non-auth Firebase services
    const { init: initFirestore } = useFirestoreService()
    initFirestore(fbServices.application)

    const { init: initFunctions } = useFunctionService()
    initFunctions(fbServices.application)

    const { init: initStorage } = useStorageService()
    initStorage(fbServices.application)

    // Return services for BootstrapService to use
    return fbServices
}
